import axios from "axios";
import { QueryClient, QueryFunction, QueryKey } from "@tanstack/react-query";

const defaultQueryFn: QueryFunction<unknown, QueryKey, never> = async ({ queryKey }) => {
  const { data } = await axios.get(`${import.meta.env.VITE_BE_URL}/${queryKey[0]}`);
  return data;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
    },
  },
});
